import styles from './NewOverdueView.module.css';
import { AlertBox, Icon } from '@iwoca/orion';
import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';
import { FormattedMessage } from 'react-intl';
import messages from './OverdueAlert.messages';

export const OverdueAlert = ({ overdueAmount }: { overdueAmount: number }) => {
    return (
        <AlertBox variant="failure" className={styles.alertBox}>
            <Icon icon="alertCircle" className={styles.icon} />
            <div className={styles.descriptionContainer}>
                <p className={styles.description}>
                    <FormattedMessage
                        {...messages.overdueAlert}
                        values={{
                            strong: (chunks) => <strong>{chunks}</strong>,
                            amount: <FormattedCurrency value={overdueAmount} />
                        }}
                    />
                </p>
            </div>
        </AlertBox>
    );
};
